import Zooming from './modules/zooming'

document.addEventListener('DOMContentLoaded', () => {
  new Zooming()
})

export default Zooming
